import { render, staticRenderFns } from "./StackedBarChartCard.vue?vue&type=template&id=154c2f0f&scoped=true"
import script from "./StackedBarChartCard.vue?vue&type=script&lang=js"
export * from "./StackedBarChartCard.vue?vue&type=script&lang=js"
import style0 from "./StackedBarChartCard.vue?vue&type=style&index=0&id=154c2f0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154c2f0f",
  null
  
)

export default component.exports